const THREE = require('three');

export const prepareObjectGeometry = (obj, scale = 1) => {
    const screen = [];
    const location = [];
    const transition = [];
    let groupGeom;
    let groupGeomName;

    obj.traverse(child => {
        if (child instanceof THREE.Mesh) {
            //
            // child.geometry is a THREE.BufferGeometry instance
            //
            const geometry = new THREE.Geometry().fromBufferGeometry(child.geometry);
            const names = child.name.split(' ');
            let name;
            let n = 0;
            let i = 0;
            let targetArray;
            let groupMeshes = true;

            while (names.length > 0) {
                name = names.shift();

                switch (name.toLowerCase()) {
                    case 'screen':
                        if (n < 1) targetArray = screen;
                        n++;

                        break;

                    case 'location':
                        if (n < 1) {
                            targetArray = location;
                            groupMeshes = false;
                        }
                        n++;

                        break;

                    case 'transition':
                        if (n < 1) targetArray = transition;
                        n++;

                        break;

                    default:
                        // Skip any not special name at the first level:
                        if (i < 1 && n < 1) break;

                        // TIP:
                        // Ungroup planes in order to apply different textures
                        // And group planes in order to apply one and the same texture

                        if (n === 1) {
                            //
                            // Group mode:
                            // Create a new group geometry of the second level if there's none with the same name
                            //
                            if (groupMeshes && name !== groupGeomName) {
                                groupGeom = new THREE.Geometry();
                                groupGeomName = name;
                                groupGeom.name = groupGeomName;

                                if (targetArray) targetArray.push(groupGeom);
                            }

                            //
                            // Ungroup mode:
                            // Add new plane for every mesh (Location: in order to set different textures)
                            //
                            if (!groupMeshes) {
                                groupGeom = new THREE.Geometry();
                                groupGeomName = names.length > 0 ? names.pop() : name;
                                groupGeom.name = groupGeomName;

                                if (targetArray) targetArray.push(groupGeom);
                            }

                            if (scale !== 1) {
                                geometry.vertices.forEach(function(v) {
                                    v.multiplyScalar(scale);
                                });
                            }

                            groupGeom.merge(geometry);

                            names.splice(0, names.length);
                        }

                        n++;

                        break;
                }
                i++;
            }

            // console.log(child, child.geometry, 'geometry', geometry, 'groupGeom', groupGeom, new THREE.Color().set(colorHex), scale);
        }
    });

    // console.log('screen', screen, 'location', location, 'transition', transition)

    return {screen, location, transition};
};

export const copyGeometry = (geom, fromGeom, scale = 1) => {
    const num = fromGeom.vertices.length;

    geom.vertices.forEach(function(v, index) {
        v.copy(fromGeom.vertices[index % num].multiplyScalar(scale));
    });

    geom.verticesNeedUpdate = true;
    geom.elementsNeedUpdate = true;
    geom.colorsNeedUpdate = true;
    // pMaterial.needsUpdate = true;

    return geom;
};

export const calcTransitionGeometry = (geom, fromGeom, toGeom, ratio = 1) => {
    const num0 = fromGeom.vertices.length;
    const num1 = toGeom.vertices.length;
    geom.vertices.forEach((v, index) => {
        const v0 = fromGeom.vertices[index % num0];
        const v1 = toGeom.vertices[index % num1];
        if (!v0 || !v1) return;

        v.x = v0.x + ratio * (v1.x - v0.x);
        v.y = v0.y + ratio * (v1.y - v0.y);
        v.z = v0.z + ratio * (v1.z - v0.z);

        // if (index === 0) console.log(v, v0, v1)
    });
    geom.verticesNeedUpdate = true;
    geom.elementsNeedUpdate = true;
    geom.colorsNeedUpdate = true;
    // pMaterial.needsUpdate = true;

    return toGeom;
};
